import createReducer from 'reducers/createReducer';

import { TournamentDetails } from 'actions/actionTypes';

const INITIAL_STATE = {
  tab: 1,
  tournamentId: 0,
  information: {},

  isRequestSuccess: null,
  isResetTournamentAwardsRequestSuccess: null,
  isTournamentAwardRecipientsSelectionRequestSuccess: null,
  isTournamentAwardAnnouncementRequestSuccess: null,

  ranking: {
    awardItem: 'Score',
    awardType: 'Stroke',
    courseId: '',
    currentPage: 1,
    pageSize: 10,
    nickname: '',
    rankingSort: 1,
    gender: null,

    isAward: false,

    maxPage: 1,
    totalCount: 0,
    list: [],

    isProcessingData: null,
    awardExceptData: {},
  },
  awardRecipients: {
    awardIndex: null,
    awardItems: [],
    awardRankings: [],
  },
  error: {
    triggered: false,
    message: '',
  },
};

const reducer = createReducer(INITIAL_STATE, {
  // 이벤트
  [TournamentDetails.CHANGE_TOURNAMENT_DETAILS_TAB]: (state, action) => {
    state.tab = action.payload.value;
  },
  [TournamentDetails.CHANGE_TOURNAMENT_RANKING_OPTION_DATA]: (state, action) => {
    state.ranking[action.payload.name] = action.payload.value;

    if (action.payload.name === 'awardItem') {
      if (action.payload.value === 'HoleInOne' || action.payload.value === 'CourseRoundPlayCount') {
        state.ranking['awardType'] = '';
        state.ranking['courseId'] = 'all';
      } else if (action.payload.value === 'Longest' || action.payload.value === 'Nearpin') {
        state.ranking['awardType'] = '';
        state.ranking['courseId'] = '';
      } else if (action.payload.value === 'Score') {
        state.ranking['awardType'] = 'Stroke';
        state.ranking['courseId'] = '';
      }
    }
  },
  [TournamentDetails.CHANGE_TOURNAMENT_AWARD_HISTORY_AWARD_INDEX]: (state, action) => {
    state.awardRecipients.awardIndex = action.payload.index;
  },
  [TournamentDetails.RESET_TOURNAMENT_RANKING_OPTION_DATA]: (state, action) => {
    state.ranking.awardItem = state.information?.awards?.[0]?.awardItems;
    state.ranking.awardType = state.information?.awards?.[0]?.awardType;
    state.ranking.courseId = INITIAL_STATE.ranking.courseId;
    state.ranking.currentPage = INITIAL_STATE.ranking.currentPage;
    state.ranking.pageSize = INITIAL_STATE.ranking.pageSize;
    state.ranking.nickname = INITIAL_STATE.ranking.nickname;
  },
  [TournamentDetails.RESET_TOURNAMENT_RANKING_DATA]: (state, action) => {
    state.ranking.maxPage = INITIAL_STATE.ranking.maxPage;
    state.ranking.totalCount = INITIAL_STATE.ranking.totalCount;
    state.ranking.list = INITIAL_STATE.ranking.list;
  },

  // 매장 대회 상세보기 조회
  [TournamentDetails.LOAD_TOURNAMENT_DETAILS_REQUEST]: (state, action) => {
    state.isRequestSuccess = null;
    state.isResetTournamentAwardsRequestSuccess = null;
    state.isTournamentAwardRecipientsSelectionRequestSuccess = null;
    state.isTournamentAwardAnnouncementRequestSuccess = null;

    state.tournamentId = action.payload.tournamentId;
  },
  [TournamentDetails.LOAD_TOURNAMENT_DETAILS_REQUEST_SUCCESS]: (state, action) => {
    state.isRequestSuccess = true;

    state.information = action.payload;
  },
  [TournamentDetails.LOAD_TOURNAMENT_DETAILS_REQUEST_FAILURE]: (state, action) => {
    state.isRequestSuccess = false;

    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 랭킹 조회
  [TournamentDetails.LOAD_TOURNAMENT_RANKING_REQUEST]: (state, action) => {
    state.isResetTournamentAwardsRequestSuccess = null;
    state.isTournamentAwardRecipientsSelectionRequestSuccess = null;

    state.ranking.isAward = action.payload.isAward;
    state.ranking.list = INITIAL_STATE.ranking.list;
  },
  [TournamentDetails.LOAD_TOURNAMENT_RANKING_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.currentPage = action.payload.currentPage;
    state.ranking.maxPage = action.payload.maxPage;
    state.ranking.totalCount = action.payload.totalCount;
    state.ranking.list = action.payload.list;
  },
  [TournamentDetails.LOAD_TOURNAMENT_RANKING_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 전체 랭킹 조회
  [TournamentDetails.LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST]: (state, action) => {
    state.isResetTournamentAwardsRequestSuccess = null;
    state.isTournamentAwardRecipientsSelectionRequestSuccess = null;

    state.ranking.isAward = action.payload.isAward;
    state.ranking.list = INITIAL_STATE.ranking.list;
  },
  [TournamentDetails.LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.list = action.payload;
  },
  [TournamentDetails.LOAD_TOURNAMENT_TOTAL_RANKING_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 수상자 목록 조회
  [TournamentDetails.LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST]: (state, action) => {
    state.isTournamentAwardAnnouncementRequestSuccess = null;

    state.awardRecipients = INITIAL_STATE.awardRecipients;
  },
  [TournamentDetails.LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST_SUCCESS]: (state, action) => {
    state.awardRecipients.awardItems = action.payload.awardItems;
    state.awardRecipients.awardRankings = action.payload.awardRankings;
  },
  [TournamentDetails.LOAD_TOURNAMENT_AWARD_RECIPIENTS_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 코스별 시상 제외
  [TournamentDetails.EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST]: (state, action) => {
    state.ranking.isProcessingData = true;
    state.ranking.awardExceptData = action.payload;
  },
  [TournamentDetails.EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.ranking.awardExceptData = INITIAL_STATE.ranking.awardExceptData;
  },
  [TournamentDetails.EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_FAILURE]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  [TournamentDetails.ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST]: (state, action) => {
    state.ranking.isProcessingData = true;
    state.ranking.awardExceptData = action.payload;
  },
  [TournamentDetails.ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.ranking.awardExceptData = INITIAL_STATE.ranking.awardExceptData;
  },
  [TournamentDetails.ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_COURSE_AWARD_REQUEST_FAILURE]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 종합 시상 제외
  [TournamentDetails.EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST]: (state, action) => {
    state.ranking.isProcessingData = true;
    state.ranking.awardExceptData = action.payload;
  },
  [TournamentDetails.EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.ranking.awardExceptData = INITIAL_STATE.ranking.awardExceptData;
  },
  [TournamentDetails.EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_FAILURE]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  [TournamentDetails.ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST]: (state, action) => {
    state.ranking.isProcessingData = true;
    state.ranking.awardExceptData = action.payload;
  },
  [TournamentDetails.ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.ranking.awardExceptData = INITIAL_STATE.ranking.awardExceptData;
  },
  [TournamentDetails.ALL_EXCEPT_TOURNAMENT_PARTICIPANTS_TOTAL_AWARD_REQUEST_FAILURE]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 참가자 추가 핸디캡 설정
  [TournamentDetails.TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST]: (state, action) => {
    state.ranking.isProcessingData = true;
    state.ranking.awardExceptData = action.payload;
  },
  [TournamentDetails.TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.ranking.awardExceptData = INITIAL_STATE.ranking.awardExceptData;
  },
  [TournamentDetails.TOURNAMENT_PARTICIPANTS_ADDITIONAL_HANDICAP_SETTING_REQUEST_FAILURE]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 시상 초기화
  [TournamentDetails.RESET_TOURNAMENT_AWARDS_REQUEST]: (state, action) => {
    state.ranking.isProcessingData = true;
    state.isResetTournamentAwardsRequestSuccess = null;
  },
  [TournamentDetails.RESET_TOURNAMENT_AWARDS_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.isResetTournamentAwardsRequestSuccess = true;
    state.ranking.awardExceptData = INITIAL_STATE.ranking.awardExceptData;
  },
  [TournamentDetails.RESET_TOURNAMENT_AWARDS_REQUEST_FAILURE]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.isResetTournamentAwardsRequestSuccess = false;
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 수상자 설정
  [TournamentDetails.TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST]: (state, action) => {
    state.ranking.isProcessingData = true;
    state.isTournamentAwardRecipientsSelectionRequestSuccess = null;
  },
  [TournamentDetails.TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST_SUCCESS]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.isTournamentAwardRecipientsSelectionRequestSuccess = true;
    state.ranking.awardExceptData = INITIAL_STATE.ranking.awardExceptData;
  },
  [TournamentDetails.TOURNAMENT_AWARD_RECIPIENTS_SELECTION_REQUEST_FAILURE]: (state, action) => {
    state.ranking.isProcessingData = false;
    state.isTournamentAwardRecipientsSelectionRequestSuccess = false;
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage
    };
  },

  // 매장 대회 시상 발표
  [TournamentDetails.TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
    state.isTournamentAwardAnnouncementRequestSuccess = null;
  },
  [TournamentDetails.TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST_SUCCESS]: (state, action) => {
    state.isTournamentAwardAnnouncementRequestSuccess = true;
  },
  [TournamentDetails.TOURNAMENT_AWARD_ANNOUNCEMENT_REQUEST_FAILURE]: (state, action) => {
    state.isTournamentAwardAnnouncementRequestSuccess = false;

    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },
});

export default reducer;
